export interface StateSportsbook {
  id: string;
  name: string;
  isOffshore: boolean;
  sportsbookCode: string;
  logoUrl?: string;
  operatorType: 'Sportsbook' | 'PickEm';
}

export interface StateData {
  id: string;
  name: string;
  abbreviation: string;
  isLegalized: boolean;
  sportsbooks: StateSportsbook[];
}

const ODDSSHOPPER_API = process.env.REACT_APP_ODDSSHOPPER_API || 'https://www.oddsshopper.com';

let cachedStateData: StateData[] | null = null;
let cachedAllSportsbooks: StateSportsbook[] | null = null;
let inFlightAllSportsbooks: Promise<StateSportsbook[]> | null = null;

export async function fetchStateSportsbooks(): Promise<StateData[]> {
  if (cachedStateData) {
    return cachedStateData;
  }

  try {
    const response = await fetch(`${ODDSSHOPPER_API}/api/states/sportsbooks`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data: StateData[] = await response.json();
    cachedStateData = data;
    return data;
  } catch (error) {
    console.error('Failed to fetch state sportsbooks:', error);
    return [];
  }
}

export async function fetchAllSportsbooks(): Promise<StateSportsbook[]> {
  if (cachedAllSportsbooks) {
    return cachedAllSportsbooks;
  }
  if (inFlightAllSportsbooks) {
    return inFlightAllSportsbooks;
  }

  inFlightAllSportsbooks = (async () => {
    try {
      const response = await fetch(`${ODDSSHOPPER_API}/api/sportsbooks`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data: StateSportsbook[] = await response.json();
      cachedAllSportsbooks = data;
      return data;
    } catch (error) {
      console.error('Failed to fetch all sportsbooks:', error);
      return [];
    } finally {
      inFlightAllSportsbooks = null;
    }
  })();

  return inFlightAllSportsbooks;
}

export function getSportsbooksForState(stateData: StateData[], stateAbbr: string): string[] {
  const state = stateData.find(s => s.abbreviation === stateAbbr);
  if (!state) return [];
  return state.sportsbooks.map(sb => sb.sportsbookCode);
}
